import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { NzModalRef } from 'ng-zorro-antd/modal';

import { CompaniesService } from '../../services';

@Component({
  selector: 'app-companies-new',
  templateUrl: './companies-new.component.html',
  styleUrls: ['./companies-new.component.scss'],
  standalone: false
})
export class CompaniesNewComponent implements OnInit {

  constructor(
    private dialogRef: NzModalRef<CompaniesNewComponent>,
    private companiesService: CompaniesService,
  ) { }

  protected disabledDate = (current: Date): boolean => this.companiesService.disabledDateForNewCompany(current);

  protected get companyNewForm(): FormGroup {
    return this.companiesService.companyNewForm;
  }

  public ngOnInit(): void {
    this.createForm();
  }

  protected clearNonDigit(e: Event): void {
    this.companiesService.clearNonDigitHandler(e);
  }

  protected onCancelClick(e: Event): void {
    e.preventDefault();
    this.dialogRef.close({ status: 'cancel' });
  }

  protected onSubmit(): void {
    this.companiesService.onCreateNewCompanyHandler(this.dialogRef);
  }

  private createForm(): void {
    this.companiesService.createNewCompanyForm();
  }
}
